var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"option",class:{ 'is-selected': _vm.isSelected },style:({ borderColor: _vm.widgetColor })},[_c('button',{staticClass:"option-button button",on:{"click":_vm.onClick}},[_c('span',{style:({ color: _vm.widgetColor })},[_vm._v(_vm._s(_vm.action.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }